import React from "react";
import LoggedInMenu from "./LoggedInMenu";
import RPaketTable from "./RPaketTable";

import { withRouter } from "react-router";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";
import OcrProcessDropzone from "./OcrProcessDropzone";

interface OcrProcess {
  createdAt: string;
  state: string;
  sum: number;
  processNumber: string;
  timestamp: number;
  images?: [
    {
      thumb: string;
      full: string;
    }
  ];
}

interface IOcrPRocessListProps {
  history: any;
  match: any;
  location: any;
}

class OcrProcessList extends React.Component<IOcrPRocessListProps> {
  state: {
    showModal: boolean;
  };

  constructor(props: any) {
    super(props);

    this.state = { showModal: false };
  }

  render() {
    return (
      <>
        <LoggedInMenu history={this.props.history} />
        <OcrProcessDropzone
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        />
        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="contentheader">
                  <Container fluid>
                    <Row className="align-items-stretch py-3">
                      <Col xs={6} lg={7}>
                        <UploaderButton
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showModal: true,
                            })
                          }
                        />
                      </Col>
                      <Col xs={6} lg={5}>
                        <SearchButton
                          history={this.props.history}
                        ></SearchButton>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <div className="sitecontent">
                  <Container fluid>
                    <Row>
                      <Col xs={12} className="pb-3">
                        <h1 className="underline">
                          <span className="icon-list"></span> Meine Vorgänge
                        </h1>
                      </Col>
                      <Col xs={12}>
                        <div className="wrapper-leistungsberichte">
                          <RPaketTable displayTopBorder="1px" />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default withRouter(OcrProcessList);
